import Vue from 'vue'
import Router from 'vue-router'
// import Hello from '@/components/Hello'
import Login from '@/pages/login'
import ClassroomList from '@/pages/classroomList'
import AgendaForm from '@/pages/agendaForm'
import MenuForm from '@/pages/menuForm'
import PageNotFound from '@/pages/404'
import BabyDiary from '@/components/diaryType/BabyDiary/index'
import store from '@/store'

Vue.use(Router)
// https://github.com/sqreen/vue-authentication-example/blob/master/src/router/index.js
let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: { name: 'classroomList' },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        guest: true
      }
    },
    {
      path: '/classroom',
      name: 'classroomList',
      component: ClassroomList,
      meta: {
        requiresAuth: true,
        transitionName: 'slide'
      }
    },
    {
      path: '/agenda/current/:classId',
      name: 'agendaForm',
      component: AgendaForm,
      meta: {
        requiresAuth: true,
        transitionName: 'slide'
      }
    },
    {
      path: '/agenda/current/:classId/menu',
      name: 'menuForm',
      component: MenuForm,
      meta: {
        requiresAuth: true,
        transitionName: 'slide'
      }
    },
    {
      path: '/test',
      name: 'test',
      component: BabyDiary,
      meta: {
        requiresAuth: true
      }
    },
    { path: '*', component: PageNotFound }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    } else {
      let user = store.getters.getProfile
      // JSON.parse(localStorage.getItem('user'))
      if (to.matched.some(record => record.meta.is_admin)) {
        if (store.getters.isProfileLoaded && user.is_admin === 1) {
          next()
        } else {
          next({ name: 'userboard' })
        }
      } else {
        next()
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (!store.getters.isAuthenticated) {
      next()
    } else {
      next({ name: 'userboard' })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js